import { useState } from 'react';
import {
  AccessGateWrapper,
  AccessGateInternal,
  AccessGateTitle,
  AccessGateParagraph,
  AccessGateErrorText,
  AccessGateButton,
  AccessGateLogo,
  AccessGateInput,
} from './AccessGate.styled';
import logo from '../../assets/primaryLogo2.png';

function AccessGate({ invalidAccessKey, onSubmit, loading }) {
  const [displayedCode, setDisplayedCode] = useState('');

  const handleSubmit = () => {
    if (displayedCode.trim()) {
      onSubmit(displayedCode.trim());
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <AccessGateWrapper>
      <AccessGateInternal>
        <AccessGateLogo
          src={logo}
          alt="MFH Logo"
          onClick={() => window.open('https://chargeathome.org/', '_blank')}
        />
        <AccessGateTitle>Welcome!</AccessGateTitle>
        <AccessGateParagraph>
          Please enter your access key to continue:
        </AccessGateParagraph>
        <AccessGateInput
          type="text"
          value={displayedCode}
          onChange={(e) => setDisplayedCode(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Access Key"
        />
        {invalidAccessKey && (
          <AccessGateErrorText>
            The key you have entered is invalid or is no longer valid.
          </AccessGateErrorText>
        )}
        <AccessGateButton
          onClick={handleSubmit}
          disabled={!displayedCode.trim() || loading}
        >
          {loading ? 'Verifying...' : 'Continue'}
        </AccessGateButton>
      </AccessGateInternal>
    </AccessGateWrapper>
  );
}

export default AccessGate;
